module.exports = __webpack_public_path__ + "static/canvasdraw-40d30128a083910dceda7a1f171ad2b1.mp4";